import React from 'react';
import { Outlet } from 'react-router';
import styles from './RootPage.module.scss';
import { Header } from 'components/header/Header';
import { Container, Grid } from '@mui/material';
import { DocumentProvider } from './documents/documentContext/DocumentContext.tsx';
import { Links } from 'application/constants/links.ts';

export const RootPage: React.FC = () => {
  const documentsDetailsMatch = Links.Authorized.OpenDocument.useMatch();
  const documentId = documentsDetailsMatch?.params.documentId;

  return (
    <DocumentProvider key={documentId} documentId={documentId}>
      <Header />
      <main className={styles.main} data-test-id="main-page-container">
        <Container fixed>
          <Grid container>
            <Grid item md={12}>
              <Outlet />
            </Grid>
          </Grid>
        </Container>
      </main>
    </DocumentProvider>
  );
};
